import { AccordionDetails, Grid2 as Grid, Slide, Typography } from '@mui/material';
import { BoxIcon, ExpertiseBox } from 'src/styledComponents/styledBoxs';
import React, { useState } from 'react';
import { StyledAccordion, StyledAccordionSummary } from 'src/styledComponents/styledAccordions';

import South from '@mui/icons-material/South';
import { content } from 'src/common/lang/en-US';
import { expertiseData } from '../../resources/data/expertiseData';

const Expertise: React.FC = () => {
    const [expanded, setExpanded] = useState<number | false>(false);

    const handleAccordionChange = (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <ExpertiseBox id="expertise" paddingX={{ lg: '10rem', md: '5rem', sm: '3rem', xs: '2rem' }}>
            <Typography color="black " marginTop={{ xs: '50px', xxl: '200px' }} variant="h2">
                {content.expertise.header}
            </Typography>
            <Grid
                container
                marginBottom={{ xs: '60px', xxl: '120px' }}
                marginTop={{ xs: '40px', xxl: '120px' }}
                spacing={5}
            >
                <Grid size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
                    <Typography color="black " variant="h4_Thin">
                        {content.expertise.subHeader}
                    </Typography>
                    <Typography color="black" marginTop="2rem" variant="h4_Thin">
                        {content.expertise.subtitle}
                    </Typography>
                </Grid>
                <Grid marginTop={'-1.5rem'} size={{ lg: 8, md: 8, sm: 12, xs: 12 }}>
                    {expertiseData.map((item, index) => (
                        <StyledAccordion
                            expanded={expanded === index}
                            key={`${item.title}-${index}`}
                            onChange={handleAccordionChange(index)}
                        >
                            <StyledAccordionSummary expandIcon={<South sx={{ color: 'black' }} />}>
                                <Typography color="black" variant="h3_Thin">
                                    {item.title}
                                </Typography>
                            </StyledAccordionSummary>
                            <AccordionDetails>
                                <Typography color="black" variant="caption1_Thin">
                                    {item.description}
                                </Typography>
                                {item.icons && (
                                    <Grid container mt={1} spacing={1} sx={{ overflow: 'hidden' }}>
                                        {item.icons.map((icon, i) => (
                                            <Grid key={'icon-' + i} size={{ xs: 'auto' }}>
                                                <Slide
                                                    direction="right"
                                                    in={expanded === index}
                                                    timeout={500 + i * 150}
                                                >
                                                    <BoxIcon
                                                        sx={{
                                                            alignItems: 'center', // Center the icon inside
                                                            display: 'flex', // Ensure proper rendering
                                                            height: { xs: '2.5rem', xxl: '4.5rem' }, // Increase height for xxl screens
                                                            justifyContent: 'center', // Center the icon inside
                                                            marginLeft: i !== 0 ? '-0.6rem' : '0',
                                                            padding: '0.5rem',
                                                            width: { xs: '2.5rem', xxl: '4.5rem' },
                                                        }}
                                                    >
                                                        {React.createElement(icon, {
                                                            style: {
                                                                display: 'block', // Ensure proper resizing
                                                                height: '100%', // Icon will take the full height of BoxIcon
                                                                width: '100%', // Icon will take the full width of BoxIcon
                                                            },
                                                        })}
                                                    </BoxIcon>
                                                </Slide>
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                            </AccordionDetails>
                        </StyledAccordion>
                    ))}
                </Grid>
            </Grid>
        </ExpertiseBox>
    );
};

export default Expertise;
